import api from './api'

// Types for Module Access
export interface ModuleAccessRecord {
  access_id: number
  module_id: number
  module_name: string
  module_description?: string
  status: number
  status_label: string
  started_at?: string | null
  finished_at?: string | null
  created_at: string
  updated_at: string
}

export interface ModuleAccessResponse {
  success: boolean
  message: string
  data: ModuleAccessRecord | ModuleAccessRecord[]
  timestamp: string
}

export interface ApiErrorResponse {
  success: false
  message: string
  error?: string
  data?: any
  timestamp: string
}

export const moduleAccessService = {
  /**
   * Get all module access records for the authenticated employee
   */
  async getMyModuleAccess(): Promise<ModuleAccessRecord[]> {
    try {
      const response = await api.get<ModuleAccessResponse>('/module-access/my-access')
      return Array.isArray(response.data.data) ? response.data.data : []
    } catch (error: any) {
      if (error.response?.data) {
        throw error.response.data as ApiErrorResponse
      }
      throw {
        success: false,
        message: 'Network error. Please check your connection and try again.',
        timestamp: new Date().toISOString()
      } as ApiErrorResponse
    }
  },

  /**
   * Get module access status for a specific module
   */
  async getModuleAccessStatus(moduleId: number): Promise<ModuleAccessRecord> {
    try {
      const response = await api.get<ModuleAccessResponse>(`/module-access/module/${moduleId}/status`)
      return response.data.data as ModuleAccessRecord
    } catch (error: any) {
      if (error.response?.data) {
        throw error.response.data as ApiErrorResponse
      }
      throw {
        success: false,
        message: 'Network error. Please check your connection and try again.',
        timestamp: new Date().toISOString()
      } as ApiErrorResponse
    }
  },

  /**
   * Start accessing a module (change status to 1)
   */
  async startModuleAccess(moduleId: number): Promise<ModuleAccessRecord> {
    try {
      const response = await api.post<ModuleAccessResponse>(`/module-access/module/${moduleId}/start`)
      return response.data.data as ModuleAccessRecord
    } catch (error: any) {
      if (error.response?.data) {
        throw error.response.data as ApiErrorResponse
      }
      throw {
        success: false,
        message: 'Network error. Please check your connection and try again.',
        timestamp: new Date().toISOString()
      } as ApiErrorResponse
    }
  },

  /**
   * Finish module access (change status to 2)
   */
  async finishModuleAccess(moduleId: number): Promise<ModuleAccessRecord> {
    try {
      const response = await api.post<ModuleAccessResponse>(`/module-access/module/${moduleId}/finish`)
      return response.data.data as ModuleAccessRecord
    } catch (error: any) {
      if (error.response?.data) {
        throw error.response.data as ApiErrorResponse
      }
      throw {
        success: false,
        message: 'Network error. Please check your connection and try again.',
        timestamp: new Date().toISOString()
      } as ApiErrorResponse
    }
  }
}

export default moduleAccessService